<template>
    <section class="content campaign-payout-list">
      <div class="row center-block">
        <div class="box">
          <!-- Box Header -->
          <div class="box-header">
            <button class="btn btn-default btn-sm" @click.prevent="exportCampaignPayouts">Export</button>
            <!-- Reload button -->
            <b-button variant="primary" size="sm" @click.stop="reload()">
              <i class="fa fa-repeat"></i>
            </b-button>
          </div>

          <v-row class="box-body" style="padding:5px 25px 0">
            <v-col cols="12" md="12" lg="12" sm="12" align="center" justify="center">
              <v-autocomplete
                filled
                :items="campaignFilterLists"
                label="Campaign"
                item-value="id"
                hide-details
                item-text="name"
                v-model="searchFilters.campaignID"
              >
                <template v-slot:item="{ item }">
                  <div>
                    {{item.name}}
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- Box Body -->
          <div class="box-body">
            <!-- Filtering input -->
            <div class="row">
            <div class="col-xs-12">
              <v-card-title v-if="!searchFilters.campaignID">
                <v-row style="justify-content:right;">
                  <!-- <v-col cols="12" sm="12" md="3" lg="3">
                    <v-autocomplete
                      v-model="searchFilters.campaignID"
                      item-value="id" 
                      item-text="name"
                      :items="campaignFilterLists"
                      label="Campaign Filter"
                      hide-details
                      outlined
                      dense
                      auto-select-first
                      @change="getAllCampaignPayouts"
                    ></v-autocomplete>
                  </v-col> -->
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <date-picker
                      className="input-field"
                      :options="{placeholder: 'Submission Date'}"
                      :date="searchFilters.submissionDate"
                      :status="subDateCal"
                      @changeDate="setSubmissionDateFilter"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <date-picker
                      className="input-field"
                      :options="{placeholder: 'Due Date'}"
                      :date="searchFilters.dueDate"
                      :status="dueDateCal"
                      @changeDate="setDueDateFilter"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="3" lg="3">
                    <v-text-field
                      class="pt-0"
                      v-model="filter"
                      append-icon="search"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-col>
                </v-row>
                <!-- <v-spacer></v-spacer>
                <v-text-field
                  v-model="filter"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field> -->
              </v-card-title>
              <div v-if="searchFilters.campaignID">
                <report-payout-lists
                  :campaignID="searchFilters.campaignID"
                  :refresh="refreshPayouts"
                  source="payout"
                />
              </div>
              <div v-else>
                <v-data-table
                  :headers="headers"
                  :items="filteredItems"
                  :search="filter"
                  class="elevation-1"
                >
                  <template v-slot:body="{items}">
                    <tbody>
                      <tr v-for="item in items" :key="item.name">
                        <td>
                          <a :href="'https://www.tiktok.com/@' + item.handle" target="_blank" v-if="item.platform === 'tiktok'">
                          <img src="/static/img/tiktok-32.png" width="20px" /> @{{ item.handle }}
                          </a>
                          <a target="_blank" v-bind:href="'https://youtube.com/' + item.handle" v-else-if="item.platform === 'youtube'"><v-icon color="#000000" small>mdi-youtube</v-icon> @{{ item.handle }}</a>
                          <a target="_blank" v-bind:href="'https://facebook.com/' + item.handle" v-else-if="item.platform === 'facebook'"><v-icon color="#000000" small>mdi-facebook</v-icon> @{{ item.handle }}</a>
                          <a :href="'https://www.xiaohongshu.com/user/profile/' + item.xhsID" target="_blank" v-else-if="item.platform === 'xiaohongshu'"
                          ><img src="/static/img/xhs-black.png" width="20px" /> @{{ item.fullName || item.handle }}</a>
                          <a :href="'https://instagram.com/' + item.handle" target="_blank" v-else>
                          <v-icon color="#000000" small>mdi-instagram</v-icon> @{{ item.handle || item.instagram  }}
                          </a>
                        </td>
                        <!-- <td>
                          <span v-if="item.platform === 'tiktok'">{{ item.fullName }}</span>
                          <span v-else>{{ item.fullName }}</span>
                        </td> -->
                        <td>{{ item.campaignName }}</td>
                        <td>{{ changeDateFormat(item.createdAt) }}</td>
                        <td class="text-center">
                          {{item.satisfaction_level_on_kobe}} / 5
                        </td>
                        <td class="text-center">
                          {{item.satisfaction_level_on_advertiser}} / 5
                        </td>
                        <td class="read-more-text">
                          <div v-if="item.promotingProducts">
                            <read-more more-str="read more" :text="item.promotingProducts" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </td>
                        <td class="read-more-text">
                          <div v-if="item.improved">
                            <read-more more-str="read more" :text="item.improved" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </td>
                        <td class="read-more-text">
                          <div v-if="item.audienceEnjoyment">
                            <read-more more-str="read more" :text="item.audienceEnjoyment" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </td>
                        <td class="read-more-text">
                          <div v-if="item.otherCampaigns">
                            <read-more more-str="read more" :text="item.otherCampaigns" link="#" less-str="read less" :max-chars="50"></read-more>
                          </div>
                          <div v-else>
                            Empty
                          </div>
                        </td>
                        <!-- <td>{{ changeDateFormat(item.toMakePaymentAt) }} ({{ calDaysLeft(item.toMakePaymentAt) }})</td> -->
                        <!-- <td>
                          <v-chip color="success" small text-color="white" v-if="item.payoutAmount">
                            <v-icon small left class="mr-0">mdi-check</v-icon> Verified
                          </v-chip>
                        </td> -->
                        <td class="text-center" style="width:115px">
                          <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn small color="secondary" class="ims-action" v-on="on"
                              @click="verifyPayout(item)"
                            >
                              <i class="fas fa-money-check-alt"></i>
                            </v-btn>
                          </template>
                          <span>Payout Verification</span>
                          </v-tooltip>
                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small color="green" v-on="on" class="ims-action"
                                :disabled="!item.instagram_post_url"
                                :href="item.instagram_post_url" target="_blank"
                              >
                                <i class="fab fa-instagram"></i>
                              </v-btn>
                            </template>
                          <span>Instagram Post</span>
                          </v-tooltip> -->
                          <!-- <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn small color="green" v-on="on" class="ims-action"
                                :disabled="!item.tiktok_post_url"
                                :href="item.tiktok_post_url" target="_blank"
                              >
                                <img src="/static/img/tiktok-32.png" width="20px" />
                              </v-btn>
                            </template>
                          <span>TikTok Post</span>
                          </v-tooltip> -->
                          <!-- <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn small color="secondary" class="ims-action"
                              :disabled="!item.other_social_media_post_url"
                              :href="item.other_social_media_post_url"
                              target="_blank" v-on="on"
                            >
                              <i class="fas fa-share-alt-square"></i>
                            </v-btn>
                          </template>
                          <span>Other Social Media Post</span>
                          </v-tooltip> -->
                          <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn small color="secondary" class="ims-action"
                              :disabled="disableViewScreenshot(item)"
                              v-on="on"
                              @click="viewImages(item)"
                            >
                              <v-icon>mdi-image-multiple</v-icon>
                            </v-btn>
                          </template>
                          <span>View Attached Screenshots</span>
                          </v-tooltip>
                          <v-tooltip v-if="item.uploadMedias.length" top>
                            <template v-slot:activator="{ on }">
                              <v-btn small color="secondary" class="ims-action"
                                :disabled="!item.uploadMedias.length"
                                v-on="on"
                                @click="downloadInvoice(item)"
                              >
                                <v-icon>mdi-download</v-icon>
                              </v-btn>
                            </template>
                            <span>Download Invoice</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                  <template v-slot:no-results>
                    <v-alert color="error" icon="warning">
                      Your search for "{{ filter }}" found no results.
                    </v-alert>
                  </template>
                </v-data-table>
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
      <payout-verification-modal v-model="payoutViewDialog" :payout="payoutViewData" @payoutAmountUpdated="getAllCampaignPayouts()"/>
      <payout-screenshots-dialog
        v-model="viewScreenShotsDialog"
        :value="viewScreenShotsDialog"
        :imagesToView="imagesToView"
       />
    </section>
</template>
<script>
import { mapState } from 'vuex';
import moment from 'moment'
import config from '@/config'
import utils from '@/utils';
import DatePicker from '@/components/scoped/custom/DatePicker'
import influencerAPIs from '../Influencer/influencerAPIs'
import paymentAPIs from '../Finance/paymentAPIs'
import PayoutVerificationModal from './PayoutVerificationModal.vue'
import PayoutScreenshotsDialog from '../Finance/PayoutScreenshotsDialog.vue'
import ReportPayoutLists from './ReportInternal/ReportPayoutLists'

export default {
  name: 'CampaignPayoutInternal',
  components: {
    PayoutVerificationModal,
    PayoutScreenshotsDialog,
    DatePicker,
    ReportPayoutLists
  },
  data() {
    return {
      headers: [
        { value: 'handle', text: 'Handle', sortable: true },
        // { value: 'fullname', text: 'Fullname', sortable: true },
        { value: 'campaignName', text: 'Campaign', sortable: true },
        { value: 'createdAt', text: 'Submitted date', sortable: true },
        { value: 'satisfaction_level_on_kobe', text: 'Satisfication Level on Kobe', sortable: true },
        { value: 'satisfaction_level_on_advertiser', text: 'Satisfication Level on Client', sortable: true },
        { value: 'promotingProducts', text: 'What do you like most about this product/service you are promoting?', sortable: true },
        { value: 'improved', text: 'What are areas of improvement about this product/service that will be valuable feedback for them?', sortable: true },
        { value: 'audienceEnjoyment', text: 'What do you think your audience enjoyed about your content?', sortable: true },
        { value: 'otherCampaigns', text: 'What other campaigns would you want to work more on with us?', sortable: true },
        // { value: 'toMakePaymentAt', text: 'To Make Payment', sortable: true },
        // { value: 'payoutAmount', text: 'Amount', sortable: true },
        { value: 'action', text: 'Actions' }
      ],
      items: [],
      filteredItems: [],
      moneyouts: [],
      lastUpdate: null,
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      refreshPayouts: 1,
      filter: null,
      payoutViewDialog: false,
      payoutViewData: null,
      viewScreenShotsDialog: false,
      imagesToView: [],
      imageViewerDialog: false,
      activeImage: '',
      searchFilters: {},
      campaignFilterLists: [],
      subDateCal: false,
      dueDateCal: false
    }
  },
  computed: {
    ...mapState({
      campaigns: state => state.campaign.campaigns
    }),
    currentUserRole: function() {
      return Number(this.$store.state.user.role)
    },
    hasPosts: function() {
      if (this.imagesToView.posts && this.imagesToView.posts.length > 0) {
        for (let post of this.imagesToView.posts) {
          if (post.instagramPostURL !== '' || (post.images && post.images.length > 0)) {
            return true
          }
        }
      }
      return false
    },
    hasStories: function() {
      if (this.imagesToView.stories && this.imagesToView.stories.length > 0) {
        for (let post of this.imagesToView.stories) {
          if (post.label !== '' || (post.images && post.images.length > 0)) {
            return true
          }
        }
      }
      return false
    },
    hasDeliverablePosts: function() {
      if (this.imagesToView.deliverablePosts && this.imagesToView.deliverablePosts.length > 0) {
        for (let allPosts of this.imagesToView.deliverablePosts) {
          for (let post of allPosts.posts) {
            if (post.label !== '' || (post.images && post.images.length > 0)) {
              return true
            }
          }
        }
      }
      return false
    }
  },
  methods: {
    viewMedia(img) {
      this.activeImage = img
      this.imageViewerDialog = true
    },
    viewImages(item) {
      this.imagesToView = item
      this.viewScreenShotsDialog = true
    },
    buttonShow(type) {
      const roleAllow = config['userPermissions']['influencer'][type]
      return roleAllow ? roleAllow.includes(this.currentUserRole) : false
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    verifyPayout(payout) {
      this.payoutViewData = payout;
      this.payoutViewDialog = true;
    },
    updateItems(newItems) {
      this.items = newItems
      this.totalRows = this.items.length
      this.setFilteredItems()
      this.filterbyDates()
    },
    getAllCampaignPayouts() {
      this.getAllMoneyOuts()
      influencerAPIs
        .getAllCampaignPayouts(this.searchFilters)
        .then(response => {
          let campaignPayouts = response.data
          // For now, we only retrieve Instagram info
          const displayItems = campaignPayouts.map(element => {
            let moneyOut = this.moneyouts.find(m => m.payoutID && m.payoutID === element.id)
            let resultData = {
              campaignName: element.campaignName,
              postID: element.postID,
              influencerID: element.influencerID,
              collaboration: element.collaboration || null,
              improved: element.improved || null,
              promotingProducts: element.promotingProducts || null,
              audienceEnjoyment: element.audienceEnjoyment || null,
              otherCampaigns: element.otherCampaigns || null,
              other_social_media_post_url: element.otherSocialMediaPostUrl,
              satisfaction_level_on_campaign: element.satisfactionLevel,
              satisfaction_level_on_kobe: element.kobeSatisfactionLevel,
              satisfaction_level_on_advertiser: element.advertiserSatisfactionLevel || 0,
              createdAt: element.createdAt,
              toMakePaymentAt: moment(element.createdAt).add(30, 'days').format(),
              payoutAmount: element.payoutAmount || '',
              // createdAt: moment(element.createdAt, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('DD-MM-YYYY HH:mm')
              images: element.images || [],
              posts: element.posts || [],
              stories: element.stories || [],
              deliverablePosts: element.deliverablePosts || [],
              uploadMedias: element.uploadMedias || []
            }
            if (element.tiktok) {
              resultData.handle = element.tiktok ? element.tiktok.tiktokHandle : ''
              resultData.fullName = element.tiktok ? element.tiktok.tiktokFullname : ''
              resultData.tiktok_post_url = element.tiktokPostURL
              resultData.platform = 'tiktok'
            }
            if (element.instagram) {
              if (typeof element.instagram === 'object') {
                resultData.handle = element.instagram ? element.instagram.instagramHandle : ''
                resultData.fullName = element.instagram ? element.instagram.instagramFullname : ''
                resultData.instagram_post_url = element.instagramPostURL
                resultData.platform = 'instagram'
              }
              if (typeof element.instagram === 'string') {
                resultData.handle = element.instagram
                resultData.platform = 'instagram'
              }
            }
            if (!resultData.handle) {
              if (element.handle) {
                resultData.handle = element.handle
                resultData.platform = element.platform || 'instagram'
                resultData.xhsID = element.xhsID || ''
              }
            }
            return Object.assign(
              {
                id: element.id,
                campaignID: element.campaignID,
                postID: element.postID
              },
              resultData,
              {moneyOut}
            )
          })

          this.updateItems(displayItems)
          this.lastUpdate = response.lastUpdate
        })
        .catch(error => {
          // Request failed.
          console.log('error', error)
        })
    },
    exportCampaignPayouts() {
      influencerAPIs
        .exportAllCampaignPayouts()
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `campaign_payouts_${moment().format('X')}.xlsx`)
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
    },
    calDaysLeft: (date) => moment().to(date),
    changeDateFormat: (date) => moment(date).format('DD-MM-YYYY'),
    async getAllMoneyOuts() {
      const resp = await paymentAPIs.getAllPayouts();
      if (resp.success) {
        this.moneyouts = resp.data.outcomes;
      }
    },
    disableViewScreenshot(item) {
      return !item.images.length > 0 && !item.posts.length > 0 && !item.stories.length > 0 && !item.deliverablePosts.length > 0
    },
    async getCampaigns() {
      let filter = {
        statuses: [
          config.campaignStatus.PAIRING_INFLUENCER,
          config.campaignStatus.ONGOING
        ]
      }
      await this.$store.dispatch('campaign/getCampaigns', filter)
      this.campaignFilterLists = [{id: '', name: 'All Campaigns'}, ...this.campaigns]
    },
    filterbyDates() {
      if (this.searchFilters.submissionDate) {
        this.filteredItems = this.items.filter(item => utils.func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === this.searchFilters.submissionDate)
      }
      if (this.searchFilters.dueDate) {
        let filterDueDate = moment(this.searchFilters.dueDate).subtract(30, 'days').format('YYYY-MM-DD')
        this.filteredItems = this.items.filter(item => utils.func.formatCustomDate(item.createdAt, 'YYYY-MM-DD') === filterDueDate)
      }
    },
    setSubmissionDateFilter(value) {
      this.searchFilters.submissionDate = value
      this.setFilteredItems()
      this.filterbyDates()
    },
    setDueDateFilter(value) {
      this.searchFilters.dueDate = value
      this.setFilteredItems()
      this.filterbyDates()
    },
    setFilteredItems() {
      this.filteredItems = Object.assign([], this.items)
    },
    reload() {
      if (this.searchFilters.campaignID) {
        this.refreshPayouts += 1
      } else {
        this.getAllCampaignPayouts()
        this.resetFilters()
      }
    },
    resetFilters() {
      this.searchFilters.submissionDate = ''
      this.searchFilters.dueDate = ''
      this.filter = ''
    },
    downloadInvoice(item) {
      console.log(item)
      if (item.uploadMedias.length) {
        let mediaOne = item.uploadMedias[0]
        utils.func.downloadFile(item.handle, mediaOne.url)
      }
    }
  },
  async created() {
    if (this.$route.query.influencerID) {
      this.searchFilters.influencerID = this.$route.query.influencerID
    }
    if (this.$route.query.campaignID) {
      this.searchFilters.campaignID = this.$route.query.campaignID
    }
    if (this.$route.query.verified) {
      this.searchFilters.verified = this.$route.query.verified
    }
    this.getAllCampaignPayouts()
    this.getCampaigns()
  }
}
</script>

<style>
  .campaign-payout-list .read-more-text p {
    margin-bottom: 0!important;
  }
  .ims-action {
    margin: 6px 1px!important;
    min-width: 35px!important;
    padding: 0px!important;
  }
</style>



// WEBPACK FOOTER //
// CampaignPayoutList.vue?040d193b